import { SettingConst } from '@faire/web-api--source/types';

/**
 * Control to enable streamlined mWeb cart and checkout experience
 * https://www.notion.so/faire/mWeb-Checkout-2152efb5c25a8089806ad4b786c7918d
 */
export const SIMPLIFIED_CHECKOUT_MWEB_250902 =
  'SIMPLIFIED_CHECKOUT_MWEB_250902' as SettingConst<
    'SIMPLIFIED_CHECKOUT_MWEB_250902',
    boolean,
    'RETAILER' | 'HOTJAR_RETAILER' | 'RETAILER_MIDDLEWARE'
  >;
